module.exports = __webpack_public_path__ + "assets/38bf7a33c0b4da44978914db3c27abe1.mp3";